import { Box, BoxProps, CheckBox } from '@jfs/ui-new'
import { FC, useEffect, useState } from 'react'
import { FlatList, ViewProps } from 'react-native'

interface AcessRightsCheckboxProps {
  heading: string
  initialCheckBoxData: { permissionCode: string; isChecked: boolean }[]
  borderBottomWidth?: number
  borderTopWidth?: number
  borderTopLeftRadius?: number
  borderTopRightRadius?: number
  borderBottomLeftRadius?: number
  borderBottomRightRadius?: number
  fieldName: string
  marginHorizontal: number
  setFieldValue: (fieldName: string, val: any) => void
}
const DEFAULT_BORDER_WIDTH = 1
export const AcessRightsCheckbox: FC<AcessRightsCheckboxProps> = ({
  heading,
  initialCheckBoxData,
  borderBottomWidth = DEFAULT_BORDER_WIDTH,
  borderTopWidth = DEFAULT_BORDER_WIDTH,
  borderTopLeftRadius = 0,
  borderTopRightRadius = 0,
  borderBottomLeftRadius = 0,
  borderBottomRightRadius = 0,
  marginHorizontal = 0,
  setFieldValue,
  fieldName,
}: AcessRightsCheckboxProps) => {
  const [checkBoxData, updateCheckBoxData] = useState(JSON.parse(JSON.stringify(initialCheckBoxData)))

  useEffect(() => {
    setFieldValue(fieldName, checkBoxData)
  }, [checkBoxData, fieldName, setFieldValue])

  const isAllChecked = () => {
    return (
      checkBoxData.filter((item: any) => {
        return !item?.isChecked
      }).length === 0
    )
  }

  const toggleAll = () => {
    const isChecked = isAllChecked()
    const updatedCheckBoxData = checkBoxData.map((data: any) => {
      data.isChecked = !isChecked
      return data
    })
    updateCheckBoxData(updatedCheckBoxData)
  }

  const _renderItem = ({ item }: any) => {
    return (
      <Box {...styles.itemContainer}>
        <CheckBox
          checked={item?.isChecked ?? false}
          onChange={() => {
            const updatedCheckBoxData = checkBoxData.map((data: any) => {
              if (data.permissionCode === item.permissionCode) {
                data.isChecked = !data.isChecked
              }
              return data
            })
            updateCheckBoxData(updatedCheckBoxData)
          }}
          iconSize={18}
          color={item?.isChecked ? 'BLUE_SHADE_PRIMARY' : 'PRIMARY_GREY'}
          textLabel={item.permissionDesc}
          textColor="PRIMARY_GREY"
          // alignBox={'flex-start'}
          fontWeight={'BOLD'}
          //color="DARK_GREY"
          fontSize={12}
          testID={'permission-sub-' + heading.replaceAll(' ', '')}
        />
      </Box>
    )
  }

  return (
    <Box
      {...styles.container}
      marginHorizontal={marginHorizontal}
      borderBottomWidth={borderBottomWidth}
      borderTopWidth={borderTopWidth}
      borderTopLeftRadius={borderTopLeftRadius}
      borderTopRightRadius={borderTopRightRadius}
      borderBottomLeftRadius={borderBottomLeftRadius}
      borderBottomRightRadius={borderBottomRightRadius}
      testID={'permission-wrapper-' + heading.replaceAll(' ', '')}>
      <Box {...styles.leftContainer}>
        <CheckBox
          checked={isAllChecked()}
          onChange={toggleAll}
          iconSize={16}
          color={'BLUE_SHADE_PRIMARY'}
          textLabel={heading}
          textColor="BLACK_21"
          fontWeight={'BOLD'}
          //color="DARK_GREY"
          fontSize={12}
          textStyle="h1Bold"
          testID={'permission-head-' + heading.replaceAll(' ', '')}
        />
      </Box>
      <Box {...styles.rightContainer}>
        <FlatList
          horizontal
          contentContainerStyle={styles.flatListContainer}
          data={checkBoxData}
          renderItem={_renderItem}
        />
      </Box>
    </Box>
  )
}

const styles = {
  container: {
    alignSelf: 'center',
    alignItems: 'flex-start',
    flexDirection: 'row',
    width: '88%',
    borderLeftWidth: DEFAULT_BORDER_WIDTH,
    borderRightWidth: DEFAULT_BORDER_WIDTH,
    borderColor: 'DISABLED_GREY',
  } as BoxProps,
  leftContainer: {
    p: 24,
    width: 280,
    borderRightWidth: DEFAULT_BORDER_WIDTH,
    borderColor: 'DISABLED_GREY',
    height: '100%',
    backgroundColor: 'BACKGROUND',
  } as BoxProps,
  rightContainer: {
    flex: 1,
    p: 24,
  } as BoxProps,
  flatListContainer: { flex: 1 } as ViewProps,
  itemContainer: { pb: 18, width: 200, pr: 24 },
}
